<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter">
<p class="firstInSection">Thanks to Robert Blincoe, Leila Sansour, Martin Delamere, Chris Sharratt, Richard Thomas, Lisanne Radice, Jane Gregory and Peter Lavery for their help and advice.</p>
<p>Thank you to Raissa Sansour for her hospitality.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?14746084